<template>
  <i v-if="status === true" class="fa-solid fa-circle-check text-success"></i>
  <i v-else-if="status === false" class="fa-solid fa-circle-xmark text-danger"></i>
  <div v-else title="Pot ser no tens permís per veure el seu calendari." v-tooltip>
    {{ status }}
    <i class="fa-solid fa-circle-question text-muted"></i>
  </div>
</template>
      
<script>
export default {
  name: "Condicion",
  props: {
    status: Boolean,
  },
  data() {
    return {};
  },
};
</script>